<section class="cmn-innerpage-wrapper">
    <div class="head">
        <h1>Coloring Images</h1>
        <div class="head-div">
            <div class="search-wrapper">
                <input type="text" class="cmn-header-search" placeholder="Search Badges" (input)="onSearch($event)" />
            </div>
            <button *appHasPermission="'ADD_COLORING'" (click)="onAddColoringImage()" class="cmn-add-btn">
                <img src="assets/images/icons/icon-add.svg" alt="Add icon" /> Add
                Coloring Images
            </button>
        </div>
    </div>

    <div *ngIf="!loading" class="itemListWrapper">
        <div class="itemWrapper" *ngFor="let coloringImage of coloringImageList">
            <div class="story-img-wrapper">
                <img [src]="coloringImage.thumbURL || '../../../assets/images/placeHolderImage.jpg'"
                    alt="coloringImage-img" (error)="onImageError($event)" />
            </div>

            <h3 class="cmn-list-title">
                {{ getEnglishTitle(coloringImage?.translations) }}
            </h3>

            <div class="action-Container">
                <div class="action-wrapper">
                    <div  *appHasPermission="'UPDATE_COLORING'" (click)="onEditColoringImage(coloringImage.id)" class="iconWrapper">
                        <img src="../../../assets/images/icons/icon-edit.svg" alt="" />
                    </div>

                    <ng-container *appHasPermission="'DELETE_COLORING'">
                        <div   *ngIf="!coloringImage.isCustom" (click)="deleteColoringImage(coloringImage.id)"
                            class="iconWrapper">
                            <img src="../../../assets/images/icons/icon-delete.svg" alt="" />
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="noData">
        <app-no-data-component></app-no-data-component>
    </div>

    <app-content-loader [visible]="loading"></app-content-loader>
</section>
